import * as t from './types'
import { createAction } from 'redux-actions'

export const assignScoreboardTypeId = createAction<number>(t.ASSIGN_SCOREBOARD_TYPE_ID)
export const assignControlId = createAction<number>(t.ASSIGN_CONTROL_ID)
export const assignApiPollingTimeInterval = createAction<number>(t.ASSIGN_API_POLLING_TIME_INTERVAL)
